import { render, staticRenderFns } from "./AllSuppliersComponent.vue?vue&type=template&id=672dc105"
import script from "./AllSuppliersComponent.vue?vue&type=script&lang=js"
export * from "./AllSuppliersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports